import { useMemo } from 'react';
import { CustomSettingsItemScheme } from '../Components/CustomSettingsItem';
import * as yup from 'yup';
import { AnySchema } from 'yup';
import { meddiYup } from '../../Base/Validation/meddiYup';

export default function useCustomSettingsForm(
	items: CustomSettingsItemScheme[],
) {
	const validationScheme = useMemo(() => {
		const shape = items.reduce<Record<string, AnySchema>>((acc, item) => {
			acc[item.key] = meddiYup.yesNoRadioList();
			return acc;
		}, {});

		return yup.object(shape);
	}, [items]);

	const defaultValues = useMemo(() => {
		return items.reduce<Record<string, boolean>>((acc, item) => {
			acc[item.key] = true;
			return acc;
		}, {});
	}, [items]);

	return { validationScheme, defaultValues };
}
